/**
 * Created by zzy on 2019/8/5.
 */
import AlarmEvents from './AlarmEvents.vue'
export default AlarmEvents



// WEBPACK FOOTER //
// ./src/views/events/AlarmEvents/index.js